import React, { useMemo } from 'react';
import { sections } from './data/onboarding';
import { useScrollSpy } from './hooks/useScrollSpy';
import { useScrollProgress } from './hooks/useScrollProgress';
import { useProgress } from './hooks/useProgress';
import { Hero } from './components/Hero';
import { SectionNav } from './components/SectionNav';
import { SectionCard } from './components/SectionCard';
import { StepList } from './components/StepList';
import { TourAreas } from './components/TourAreas';
import { TogetherPanel } from './components/TogetherPanel';
import { ExploreGrid } from './components/ExploreGrid';
import { NeedAHand } from './components/NeedAHand';
import { TopNotices } from './components/TopNotices';
import { Reveal } from './components/Reveal';
const togetherIntro: Record<string, string> = {
  'ai-knowledge-base': 'Your Voice AI receptionist answers callers using a knowledge base about your business — so it sounds like someone who actually works for you. We build this with you.',
  'ai-agent-number': 'Your Voice AI runs on its own dedicated phone number and answers 24/7, so nothing rings out. We set up the number and the agent with you.'
};
export function App() {
  const ids = useMemo(() => [...sections.map(section => section.id), 'need-a-hand'], []);
  const activeId = useScrollSpy(ids);
  const scrollProgress = useScrollProgress();
  const {
    done,
    isDone,
    toggle
  } = useProgress();
  return <div className="min-h-full w-full bg-[#0a0a0a] text-white" data-id="element-0" data-mp="2zm4vedw4z0yn">
      <Hero data-id="element-1" data-mp="33mf1rrnubte1" />

      <div className="mx-auto flex w-full max-w-6xl flex-col px-0 pb-20 sm:pb-28 lg:flex-row lg:gap-10 lg:px-8 lg:pt-12" data-id="element-2" data-mp="33lwy49yumcw3">
        <SectionNav sections={sections} activeId={activeId} isDone={isDone} doneCount={done.filter(id => id !== 'need-a-hand').length} scrollProgress={scrollProgress} data-id="element-3" data-mp="38l05i12awv78" />

        <main className="min-w-0 flex-1 space-y-5 px-5 pt-8 sm:space-y-6 sm:px-8 lg:px-0 lg:pt-0" data-id="element-4" data-mp="nxn53r85d1mu">
          <Reveal data-id="element-5" data-mp="swqbbezv5dwe">
            <TopNotices data-id="element-6" data-mp="36hzxgtw5a5z" />
          </Reveal>

          {sections.map(section => <Reveal key={section.id} data-id="element-7" data-mp="38b7cycbvyf1">
              <SectionCard section={section} done={isDone(section.id)} onToggleDone={() => toggle(section.id)} tone={section.kind === 'white-glove' ? 'together' : 'default'} data-id="element-8" data-mp="3udkm1tuvgq9c">
                {section.kind === 'tour' && <>
                    {section.steps && <StepList steps={section.steps} data-id="element-9" data-mp="3gja6a20us6ff" />}
                    {section.areas && <TourAreas areas={section.areas} data-id="element-10" data-mp="3bnmfji6q357t" />}
                  </>}

                {section.kind === 'white-glove' && section.togetherPoints && <TogetherPanel intro={togetherIntro[section.id] ?? ''} points={section.togetherPoints} data-id="element-11" data-mp="3lk7mwa67sset" />}

                {section.kind === 'explore' && section.items && <ExploreGrid items={section.items} data-id="element-12" data-mp="2stpmxi0sf75m" />}

                {section.kind === 'steps' && section.steps && <StepList steps={section.steps} data-id="element-13" data-mp="1d4ztku6qf4s1" />}
              </SectionCard>
            </Reveal>)}

          <Reveal className="pt-2" data-id="element-14" data-mp="ygwkvd1b1ezj">
            <NeedAHand data-id="element-15" data-mp="ydqvrxsoed3t" />
          </Reveal>
        </main>
      </div>
    </div>;
}